/**
 * Select Search Filter Module
 *
 * 検索フィルターの選択を管理するモジュール
 */
export function selectSearchFilter() {
	document.body.addEventListener("click", (e) => {
		const item = e.target.closest('[data-search-id]');
		if (!item) return;

		const searchId = item.dataset.searchId;
		const searchName = item.dataset.searchName;
		const filterType = item.dataset.searchFilter; // "tag" または "area"

		// 対応するボタンに反映
		const targetSpans = document.querySelectorAll(`[data-search-target="${filterType}"]`);
		if (targetSpans.length === 0) return;
		targetSpans.forEach((targetSpan) => {
			targetSpan.textContent = searchName;
			targetSpan.dataset.searchId = searchId;
		});

		// ダイアログを閉じる（対象の親 dialog を探して close）
		const dialog = item.closest("dialog");
		if (dialog) {
			dialog.close();
		}
	});
}
